var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnDestroy, OnInit } from '@angular/core';
import { DetailsService } from '../details.service';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import * as moment from 'moment';
import { getLimitsSelector } from '../../shared/limits/limits.reducer';
import { hideRecordingsNotAvailableInPlan } from '../../shared/limits/limitsHelper';
import { Store } from '@ngrx/store';
var CallDetailsComponent = /** @class */ (function () {
    function CallDetailsComponent(detailsService, store) {
        this.detailsService = detailsService;
        this.store = store;
        this.recordingEvents = [
            'REFUSE',
            'INCOMING_CALL',
            'INCOMING_CALL_ANSWERED',
            'INCOMING_CALL_REDIRECTED',
            'INCOMING_CALL_NOT_ANSWERED',
            'CONFERENCE_CALL',
            'TRANSFER_CALL'
        ];
        this.recordingsStorageDays = 0;
        this.eventFetchTimeoutId = null;
    }
    CallDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.detailsService.onSetEventId.subscribe(function (id) {
            _this.eventId = id;
        });
        this.store.select(getLimitsSelector).subscribe(function (limits) {
            _this.recordingsStorageDays = limits.recordingsStorageDays;
        });
        this.loadEvent();
    };
    CallDetailsComponent.prototype.ngOnDestroy = function () {
        if (this.eventFetchTimeoutId) {
            window.clearTimeout(this.eventFetchTimeoutId);
        }
    };
    CallDetailsComponent.prototype.loadEvent = function () {
        var _this = this;
        this.detailsService.getCallDetails(this.eventId).subscribe(function (event) {
            _this.event = hideRecordingsNotAvailableInPlan(_this.recordingsStorageDays, event);
            _this.event = __assign({}, _this.event, { name: event.contactName, surname: event.contactSurname });
            _this.spinnerVisible = _this.event.answered && !_this.event.recordingExists;
            if (_this.event && _this.event.contacts) {
                _this.assignedContacts = _this.event.contacts.map(function (item) {
                    var contactNumber = _this.getEmphasizedNumber(item.alternativeMsisdns);
                    var parsedNumber = parsePhoneNumberFromString(contactNumber);
                    return __assign({}, item, { extendedMsisdns: {
                            msisdn: contactNumber ? _this.detailsService.getFormatedNumber(contactNumber) : null,
                            isoCountry: contactNumber && parsedNumber && parsedNumber.country ? parsedNumber.country.toLowerCase() : null
                        } });
                });
            }
            if (_this.event && _this.event.id) {
                _this.recordUrl = _this.detailsService.getRecordingUrl(_this.event.id);
                _this.voiceMailFileName = _this.detailsService.createVoicemailFilename(_this.event);
            }
            _this.event.startDate = moment(_this.event.startDate).format('LTS,  L');
        });
        if (!this.event || (this.event && !this.event.recordingExists)) {
            this.eventFetchTimeoutId = setTimeout(function () {
                _this.loadEvent();
            }, 20000);
        }
    };
    CallDetailsComponent.prototype.getEmphasizedNumber = function (list, compareNumber) {
        if (compareNumber === void 0) { compareNumber = this.event.msisdn; }
        if (compareNumber) {
            return list.filter(function (number) { return number === compareNumber; })[0];
        }
        else {
            return list[0];
        }
    };
    return CallDetailsComponent;
}());
export { CallDetailsComponent };
